// Dropdown.tsx
import React, { ReactNode } from 'react';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { Loading } from './Loading';

interface DropdownAction {
    label: string;
    action: () => Promise<void>;
}

interface DynamicDropdownProps {
    label: ReactNode;
    ariaLabel?: string;
    isDisabled?: boolean;
    loading?: boolean;
    unstyled?: boolean;
    buttonClass: string;
    actions: DropdownAction[];
}

const Dropdown: React.FC<DynamicDropdownProps> = ({
                                                      label,
                                                      ariaLabel,
                                                      isDisabled = false,
                                                      loading = false,
                                                      unstyled = false,
                                                      actions,
                                                      buttonClass,
                                                  }) => {
    const handleActionClick = async (action: () => Promise<void>) => {
        await action();
    };

    return (
        <Menu as="div" className="inline-block text-left">
            <div>
                <MenuButton
                    as="button"
                    type="button"
                    disabled={isDisabled || loading}
                    aria-label={ariaLabel}
                    className={`${loading ? 'opacity-70' : ''} ${unstyled ? '' : 'sf-icon-button rounded-xl px-3 py-2'} ${buttonClass}`}
                >
                    <div className="flex items-center gap-2">
                        {loading && <Loading size="xs" />} {label}
                    </div>
                </MenuButton>
            </div>

            {!!actions?.length && (
                <MenuItems
                    anchor="bottom start"
                    transition
                    className="sf-dropdown-content z-[9999] min-w-[13rem] rounded-2xl p-2 [--anchor-gap:6px] [--anchor-padding:8px] transition focus:outline-none data-[closed]:scale-95 data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                >
                    <div className="space-y-1">
                        {actions.map((action, index) => (
                            <MenuItem key={index}>
                                <button
                                    type="button"
                                    onClick={() => handleActionClick(action.action)}
                                    className="sf-menu-item block w-full rounded-xl px-3 py-2.5 text-left text-sm font-semibold text-base-content/75 data-[focus]:bg-primary/10 data-[focus]:text-base-content data-[focus]:outline-none"
                                >
                                    {action.label}
                                </button>
                            </MenuItem>
                        ))}
                    </div>
                </MenuItems>
            )}
        </Menu>
    );
};

export default Dropdown;
